import * as Yup from 'yup';

import { createLocale } from 'locales';

const globalLocalize = createLocale('global');

export default Yup.object().shape({
  sdb_account_name: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .min(0)
    .max(100),
  sdb_api_key: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .min(0)
    .max(100),
});
